<div class="main-content m-2 py-3">
    <div class="payments-container">
      <h3 class="block-title px-2 mb-2" translate>
        <!-- pages.newRetailer.payments 
        <span *hideIfUnauthorized="'Invoice Report'"
          ><button
            mat-stroked-button
            class="bg-theme ms-0"
            routerLink="addinvoice"
          >
            <i class="mi mi-add"></i>
            {{ "pages.newRetailer.newInvoice" | translate }}
          </button> 
        </span> -->
      </h3>
    </div>
    <div class="invoices-container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="invoices-blk">
            <div class="retailer-details-grid search-holder">
              <ul class="list-inline grid-top-actions w-90 mb-3">
                <li class="list-inline-item">
                  <p class="mb-2 mx-2">{{'pages.Creditlinereport.From' | translate }}</p>
                </li>
                <li class="list-inline-item">
                  <div class="calendar-btn">
                    <input
                      matInput
                      [matDatepicker]="dpFrom"
                      disabled
                      [min]="minFromDate"
                      placeholder="MM/DD/YYYY"
                      [max]="maxDate"
                      (dateChange)="changeFromDate($event)"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="dpFrom"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #dpFrom disabled="false"></mat-datepicker>
                  </div>
                </li>
                <li class="list-inline-item">
                  <p class="mb-2 mx-2">{{'pages.Creditlinereport.To' | translate }}</p>
                </li>
                <li class="list-inline-item">
                  <div class="calendar-btn">
                    <input
                      matInput
                      [matDatepicker]="dpTo"
                      disabled
                      [min]="minToDate"
                      placeholder="MM/DD/YYYY"
                      [max]="maxDate"
                      (dateChange)="changeToDate($event)"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="dpTo"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #dpTo disabled="false"></mat-datepicker>
                  </div>
                </li>
                <li class="list-inline-item ">
                  <input
                    type="text"
                    placeholder="{{ 'pages.newRetailer.search' | translate }}"
                    matInput
                    class="
                      rounded-pill
                      px-3
                      py-2
                      border-0
                      bg-light
                      w-100
                      input-search
                      ms-3 
                    "
                    (keyup)="quickSearch()"
                    [(ngModel)]="searchValue"
                  />
                  <i
                    color="primary"
                    class="search-icon-holder"
                    matSuffix
                    mat-icon-button
                    aria-label="Search"
                  >
                    <mat-icon>search</mat-icon>
                  </i>
                </li>
  
                <li class="list-inline-item float-end">
                  <button
                    mat-stroked-button
                    class="bg-theme"
                    (click)="exportData()"
                  >
                    {{ "pages.newRetailer.download" | translate }}
                    <i class="mi mi-save-alt"></i>
                  </button>
                </li>
  
                <!-- <li class="list-inline-item ms-2 float-end d-none d-xxl-block d-xl-none ">
                  <button
                    mat-stroked-button
                    class="bg-theme shadow"
                    [disabled]="!isRowSelected"
                    (click)="updateInvoice()"
                    *hideIfUnauthorized="'Creating New Invoice'"
                  >
                    {{ "pages.newRetailer.edit" | translate }}
                    <i class="mi mi-drive-file-rename-outline"></i>
                  </button>
                </li> -->
                <!-- <li
                  class="list-inline-item float-end ms-2"
                  *hideIfUnauthorized="'Creating New Invoice'"
                >
                  <button
                    mat-stroked-button
                    class="bg-theme ms-0"
                    routerLink="addinvoice"
                  >
                    <i class="mi mi-add"></i>
                    {{ "pages.newRetailer.newInvoice" | translate }}
                  </button>
                </li> -->
              </ul>
              <hr class="mb-0" />
              <div class="row">
                <div class="col-lg-5 col-md-4 col-sm-4 col-xs-12">
                  <div
                    class="mt-3 payments-blk card bg-theme-light rounded border-0"
                  >
                    <table class="table table-borderless table-responsive">
                      <thead class="thead-inverse">
                        <tr>
                          <th class="table-title">
                            {{ 'pages.Invoicereport.Totalreceivedthismonth' | translate}}
                          </th>
                          <th class="table-title">
                            <i
                              class="
                                small-icon
                                text-danger
                                mi mi-fiber-manual-record
                              "
                            ></i>
                            Pending
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td scope="row" class="table-row">
                            <span>{{ totalAmtPerMonth | currency }} </span>
                          </td>
                          <td scope="row" class="table-row amount-pending">
                            <span class="ms-3">{{
                              pendingAmounts | currency
                            }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- <div class="col-lg-1 mt-3">
                    <button
                      mat-stroked-button
                      class="bg-theme shadow d-none d-xxl-none d-xl-block d-lg-none d-md-block d-sm-block"
                      [disabled]="!isRowSelected"
                      (click)="updateInvoice()"
                      *hideIfUnauthorized="'Creating New Invoice'"
                    >
                      {{ "pages.newRetailer.edit" | translate }}
                      <i class="mi mi-drive-file-rename-outline"></i>
                    </button>
                </div> -->
              </div>
              <hr class="mb-0" />
  
              <ag-grid-angular
                style="width: 100%; height: 65vh"
                class="ag-theme-material"
                [rowHeight]="40"
                [enableFilter]="true"
                [enableSorting]="true"
                [enableColResize]="true"
                [rowSelection]="rowSelection"
                [rowData]="rowData"
                [columnDefs]="columnDefs"
                (gridReady)="onGridReady($event)"
                (selectionChanged)="onSelectionChanged($event)"
              >
              </ag-grid-angular>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  